import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import ImpressumView from '../views/ImpressumView.vue';
import DatenschutzView from '../views/DataSecurityView.vue';

export default createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    { path: '/', component: HomeView },
    { path: '/impressum', component: ImpressumView },
    { path: '/datenschutz', component: DatenschutzView },
    { path: '/:pathMatch(.*)*', redirect: '/' }
  ],
  scrollBehavior(to: { hash?: string }) {
    if (to.hash) return { el: to.hash, behavior: 'smooth' };
    return { top: 0 };
  }
});
